var map = {
	"./main/activeDayCountReport/activeDayCount.module": [
		"./src/app/main/activeDayCountReport/activeDayCount.module.ts",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~c24f09eb",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~8ad7246b",
		"main-activeDayCountReport-activeDayCount-module"
	],
	"./main/adjust-payment/adjust-payment.module": [
		"./src/app/main/adjust-payment/adjust-payment.module.ts",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~c24f09eb",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~8ad7246b",
		"default~main-adjust-payment-adjust-payment-module~main-dms-payment-dms-payment-module",
		"main-adjust-payment-adjust-payment-module"
	],
	"./main/admin-settings/admin-settings.module": [
		"./src/app/main/admin-settings/admin-settings.module.ts",
		"common",
		"main-admin-settings-admin-settings-module"
	],
	"./main/allowance/allowance.module": [
		"./src/app/main/allowance/allowance.module.ts",
		"default~main-allowance-allowance-module~main-central-stock-central-stock-module~main-exam-exam-modul~88d10046",
		"default~main-allowance-allowance-module~main-exam-exam-module~main-exam-v2-exam-v2-module~main-surve~592641c7",
		"common",
		"main-allowance-allowance-module"
	],
	"./main/attendance/attendance.module": [
		"./src/app/main/attendance/attendance.module.ts",
		"common",
		"main-attendance-attendance-module"
	],
	"./main/authentication/auth.module": [
		"./src/app/main/authentication/auth.module.ts",
		"main-authentication-auth-module"
	],
	"./main/bank-account/bank-account.module": [
		"./src/app/main/bank-account/bank-account.module.ts",
		"common",
		"main-bank-account-bank-account-module"
	],
	"./main/bill-pending-organization/bill-pending-organization.module": [
		"./src/app/main/bill-pending-organization/bill-pending-organization.module.ts",
		"main-bill-pending-organization-bill-pending-organization-module"
	],
	"./main/campaign/campaign.module": [
		"./src/app/main/campaign/campaign.module.ts",
		"common",
		"main-campaign-campaign-module"
	],
	"./main/central-stock/central-stock-module": [
		"./src/app/main/central-stock/central-stock-module.ts",
		"default~main-allowance-allowance-module~main-central-stock-central-stock-module~main-exam-exam-modul~88d10046",
		"default~main-central-stock-central-stock-module~main-patient-patient-module",
		"common",
		"main-central-stock-central-stock-module"
	],
	"./main/chamber-type/chamber-type.module": [
		"./src/app/main/chamber-type/chamber-type.module.ts",
		"common",
		"main-chamber-type-chamber-type-module"
	],
	"./main/chemist-approval-rules/chemist-approval-rules.module": [
		"./src/app/main/chemist-approval-rules/chemist-approval-rules.module.ts",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~c24f09eb",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~8ad7246b",
		"common",
		"main-chemist-approval-rules-chemist-approval-rules-module"
	],
	"./main/chemist-ledger/chemist-ledger.module": [
		"./src/app/main/chemist-ledger/chemist-ledger.module.ts",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~c24f09eb",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~8ad7246b",
		"default~main-chemist-ledger-chemist-ledger-module~main-dms-sales-return-dms-sales-return-module~main~658022d0",
		"main-chemist-ledger-chemist-ledger-module"
	],
	"./main/chemist-type/chemist-type.module": [
		"./src/app/main/chemist-type/chemist-type.module.ts",
		"common",
		"main-chemist-type-chemist-type-module"
	],
	"./main/chemist-visit-type/chemist-visit-type.module": [
		"./src/app/main/chemist-visit-type/chemist-visit-type.module.ts",
		"common",
		"main-chemist-visit-type-chemist-visit-type-module"
	],
	"./main/chemist/chemist.module": [
		"./src/app/main/chemist/chemist.module.ts",
		"common",
		"main-chemist-chemist-module"
	],
	"./main/chemistSurveyRespnd/chemist-survey-respond.module": [
		"./src/app/main/chemistSurveyRespnd/chemist-survey-respond.module.ts",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~c24f09eb",
		"default~main-chemistSurveyRespnd-chemist-survey-respond-module~main-dashboard-dashboard-module~main-~99ead755",
		"default~main-chemistSurveyRespnd-chemist-survey-respond-module~main-exam-exam-module",
		"common",
		"main-chemistSurveyRespnd-chemist-survey-respond-module"
	],
	"./main/chemistVisit/chemistVisit.module": [
		"./src/app/main/chemistVisit/chemistVisit.module.ts",
		"common",
		"main-chemistVisit-chemistVisit-module"
	],
	"./main/competitor-brand/competitor-brand.module": [
		"./src/app/main/competitor-brand/competitor-brand.module.ts",
		"common",
		"main-competitor-brand-competitor-brand-module"
	],
	"./main/competitor/competitor.module": [
		"./src/app/main/competitor/competitor.module.ts",
		"common",
		"main-competitor-competitor-module"
	],
	"./main/contact-type/contact-type.module": [
		"./src/app/main/contact-type/contact-type.module.ts",
		"common",
		"main-contact-type-contact-type-module"
	],
	"./main/customerApproveRules/customerApproveRules.module": [
		"./src/app/main/customerApproveRules/customerApproveRules.module.ts",
		"main-customerApproveRules-customerApproveRules-module"
	],
	"./main/da-claim/da-claim.module": [
		"./src/app/main/da-claim/da-claim.module.ts",
		"main-da-claim-da-claim-module"
	],
	"./main/daily-shift/daily-shift.module": [
		"./src/app/main/daily-shift/daily-shift.module.ts",
		"common",
		"main-daily-shift-daily-shift-module"
	],
	"./main/dashboard/dashboard.module": [
		"./src/app/main/dashboard/dashboard.module.ts",
		"default~main-chemistSurveyRespnd-chemist-survey-respond-module~main-dashboard-dashboard-module~main-~99ead755",
		"common",
		"main-dashboard-dashboard-module"
	],
	"./main/degree/degree.module": [
		"./src/app/main/degree/degree.module.ts",
		"common",
		"main-degree-degree-module"
	],
	"./main/delivary/delivary.module": [
		"./src/app/main/delivary/delivary.module.ts",
		"main-delivary-delivary-module"
	],
	"./main/delivery-return/delivery-return.module": [
		"./src/app/main/delivery-return/delivery-return.module.ts",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~c24f09eb",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~8ad7246b",
		"common",
		"main-delivery-return-delivery-return-module"
	],
	"./main/department/department.module": [
		"./src/app/main/department/department.module.ts",
		"common",
		"main-department-department-module"
	],
	"./main/depot-challan/depot-challan.module": [
		"./src/app/main/depot-challan/depot-challan.module.ts",
		"common",
		"main-depot-challan-depot-challan-module"
	],
	"./main/depot-product-batch/depot-product-batch.module": [
		"./src/app/main/depot-product-batch/depot-product-batch.module.ts",
		"common",
		"main-depot-product-batch-depot-product-batch-module"
	],
	"./main/depot-requisition/depot-requisition.module": [
		"./src/app/main/depot-requisition/depot-requisition.module.ts",
		"common",
		"main-depot-requisition-depot-requisition-module"
	],
	"./main/depot-type/depot-type.module": [
		"./src/app/main/depot-type/depot-type.module.ts",
		"common",
		"main-depot-type-depot-type-module"
	],
	"./main/depot/depot.module": [
		"./src/app/main/depot/depot.module.ts",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~c24f09eb",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~8ad7246b",
		"default~main-depot-depot-module~main-doctor-record-doctor-record-module~main-incentive-collection-in~222b3972",
		"default~main-depot-depot-module~main-doctor-record-doctor-record-module~main-incentive-collection-in~90be9925",
		"common",
		"main-depot-depot-module"
	],
	"./main/dms-campaign/dms-campaign.module": [
		"./src/app/main/dms-campaign/dms-campaign.module.ts",
		"common",
		"main-dms-campaign-dms-campaign-module"
	],
	"./main/dms-invoice/dms-invoice.module": [
		"./src/app/main/dms-invoice/dms-invoice.module.ts",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~c24f09eb",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~8ad7246b",
		"default~main-dms-invoice-dms-invoice-module~main-doctor-proposal-doctor-proposal-module",
		"common",
		"main-dms-invoice-dms-invoice-module"
	],
	"./main/dms-order/dms-order.module": [
		"./src/app/main/dms-order/dms-order.module.ts",
		"common",
		"main-dms-order-dms-order-module"
	],
	"./main/dms-payment/dms-payment.module": [
		"./src/app/main/dms-payment/dms-payment.module.ts",
		"default~main-adjust-payment-adjust-payment-module~main-dms-payment-dms-payment-module",
		"main-dms-payment-dms-payment-module"
	],
	"./main/dms-return-reason/dms-return-reason.module": [
		"./src/app/main/dms-return-reason/dms-return-reason.module.ts",
		"common",
		"main-dms-return-reason-dms-return-reason-module"
	],
	"./main/dms-sales-return/dms-sales-return.module": [
		"./src/app/main/dms-sales-return/dms-sales-return.module.ts",
		"default~main-chemist-ledger-chemist-ledger-module~main-dms-sales-return-dms-sales-return-module~main~658022d0",
		"main-dms-sales-return-dms-sales-return-module"
	],
	"./main/doctor-approval-rules/doctorApproveRules.module": [
		"./src/app/main/doctor-approval-rules/doctorApproveRules.module.ts",
		"main-doctor-approval-rules-doctorApproveRules-module"
	],
	"./main/doctor-category/doctor-category.module": [
		"./src/app/main/doctor-category/doctor-category.module.ts",
		"common",
		"main-doctor-category-doctor-category-module"
	],
	"./main/doctor-designation/doctor-designation.module": [
		"./src/app/main/doctor-designation/doctor-designation.module.ts",
		"common",
		"main-doctor-designation-doctor-designation-module"
	],
	"./main/doctor-image-type/doctor-image-type.module": [
		"./src/app/main/doctor-image-type/doctor-image-type.module.ts",
		"common",
		"main-doctor-image-type-doctor-image-type-module"
	],
	"./main/doctor-order-report/doctor-order-report.module": [
		"./src/app/main/doctor-order-report/doctor-order-report.module.ts",
		"main-doctor-order-report-doctor-order-report-module"
	],
	"./main/doctor-order/doctor-order.module": [
		"./src/app/main/doctor-order/doctor-order.module.ts",
		"common",
		"main-doctor-order-doctor-order-module"
	],
	"./main/doctor-proposal/doctor-proposal.module": [
		"./src/app/main/doctor-proposal/doctor-proposal.module.ts",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~c24f09eb",
		"default~main-dms-invoice-dms-invoice-module~main-doctor-proposal-doctor-proposal-module",
		"common",
		"main-doctor-proposal-doctor-proposal-module"
	],
	"./main/doctor-record/doctor-record.module": [
		"./src/app/main/doctor-record/doctor-record.module.ts",
		"default~main-depot-depot-module~main-doctor-record-doctor-record-module~main-incentive-collection-in~222b3972",
		"default~main-depot-depot-module~main-doctor-record-doctor-record-module~main-incentive-collection-in~90be9925",
		"common",
		"main-doctor-record-doctor-record-module"
	],
	"./main/doctor-required-visit-type/doctor-required-visit-type.module": [
		"./src/app/main/doctor-required-visit-type/doctor-required-visit-type.module.ts",
		"common",
		"main-doctor-required-visit-type-doctor-required-visit-type-module"
	],
	"./main/doctor-service/doctor-service.module": [
		"./src/app/main/doctor-service/doctor-service.module.ts",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~c24f09eb",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~8ad7246b",
		"common",
		"main-doctor-service-doctor-service-module"
	],
	"./main/doctor-visit-plan/doctor-visit-plan.module": [
		"./src/app/main/doctor-visit-plan/doctor-visit-plan.module.ts",
		"main-doctor-visit-plan-doctor-visit-plan-module"
	],
	"./main/doctor-visit-type/doctor-visit-type.module": [
		"./src/app/main/doctor-visit-type/doctor-visit-type.module.ts",
		"common",
		"main-doctor-visit-type-doctor-visit-type-module"
	],
	"./main/doctor-visit/doctor-visit.module": [
		"./src/app/main/doctor-visit/doctor-visit.module.ts",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~c24f09eb",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~8ad7246b",
		"common",
		"main-doctor-visit-doctor-visit-module"
	],
	"./main/doctor/doctor.module": [
		"./src/app/main/doctor/doctor.module.ts",
		"default~main-doctor-doctor-module~main-survey-doctor-survey-doctor-module",
		"common",
		"main-doctor-doctor-module"
	],
	"./main/doctorVisit/doctorVisit.module": [
		"./src/app/main/doctorVisit/doctorVisit.module.ts",
		"common",
		"main-doctorVisit-doctorVisit-module"
	],
	"./main/downloads/downloads.module": [
		"./src/app/main/downloads/downloads.module.ts",
		"main-downloads-downloads-module"
	],
	"./main/due-report/due-report.module": [
		"./src/app/main/due-report/due-report.module.ts",
		"main-due-report-due-report-module"
	],
	"./main/employeeApproveRules/employeeApproveRules.module": [
		"./src/app/main/employeeApproveRules/employeeApproveRules.module.ts",
		"common",
		"main-employeeApproveRules-employeeApproveRules-module"
	],
	"./main/exam-list/exam-list.module": [
		"./src/app/main/exam-list/exam-list.module.ts",
		"main-exam-list-exam-list-module"
	],
	"./main/exam-v2/exam-v2.module": [
		"./src/app/main/exam-v2/exam-v2.module.ts",
		"default~main-allowance-allowance-module~main-central-stock-central-stock-module~main-exam-exam-modul~88d10046",
		"default~main-allowance-allowance-module~main-exam-exam-module~main-exam-v2-exam-v2-module~main-surve~592641c7",
		"default~main-chemistSurveyRespnd-chemist-survey-respond-module~main-dashboard-dashboard-module~main-~99ead755",
		"main-exam-v2-exam-v2-module"
	],
	"./main/exam/exam.module": [
		"./src/app/main/exam/exam.module.ts",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~c24f09eb",
		"default~main-allowance-allowance-module~main-central-stock-central-stock-module~main-exam-exam-modul~88d10046",
		"default~main-allowance-allowance-module~main-exam-exam-module~main-exam-v2-exam-v2-module~main-surve~592641c7",
		"default~main-chemistSurveyRespnd-chemist-survey-respond-module~main-exam-exam-module",
		"common",
		"main-exam-exam-module"
	],
	"./main/expenseclaim/expenseclaim.module": [
		"./src/app/main/expenseclaim/expenseclaim.module.ts",
		"common",
		"main-expenseclaim-expenseclaim-module"
	],
	"./main/expenseclaimApproveRules/expenseclaimApproveRules.module": [
		"./src/app/main/expenseclaimApproveRules/expenseclaimApproveRules.module.ts",
		"main-expenseclaimApproveRules-expenseclaimApproveRules-module"
	],
	"./main/expensetype/expense-type.module": [
		"./src/app/main/expensetype/expense-type.module.ts",
		"common",
		"main-expensetype-expense-type-module"
	],
	"./main/generic-group/generic-group.module": [
		"./src/app/main/generic-group/generic-group.module.ts",
		"common",
		"main-generic-group-generic-group-module"
	],
	"./main/geo-market/geo-market.module": [
		"./src/app/main/geo-market/geo-market.module.ts",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~c24f09eb",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~8ad7246b",
		"common",
		"main-geo-market-geo-market-module"
	],
	"./main/holiday/holiday.module": [
		"./src/app/main/holiday/holiday.module.ts",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~c24f09eb",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~8ad7246b",
		"common",
		"main-holiday-holiday-module"
	],
	"./main/incentive-collection/incentive-collection.module": [
		"./src/app/main/incentive-collection/incentive-collection.module.ts",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~c24f09eb",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~8ad7246b",
		"default~main-depot-depot-module~main-doctor-record-doctor-record-module~main-incentive-collection-in~222b3972",
		"default~main-depot-depot-module~main-doctor-record-doctor-record-module~main-incentive-collection-in~90be9925",
		"main-incentive-collection-incentive-collection-module"
	],
	"./main/institute-type/institute-type.module": [
		"./src/app/main/institute-type/institute-type.module.ts",
		"common",
		"main-institute-type-institute-type-module"
	],
	"./main/institute/institute.module": [
		"./src/app/main/institute/institute.module.ts",
		"common",
		"main-institute-institute-module"
	],
	"./main/inv0ice/inv0ice.module": [
		"./src/app/main/inv0ice/inv0ice.module.ts",
		"common",
		"main-inv0ice-inv0ice-module"
	],
	"./main/invoice-alpha/invoice-alpha.module": [
		"./src/app/main/invoice-alpha/invoice-alpha.module.ts",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~c24f09eb",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~8ad7246b",
		"common",
		"main-invoice-alpha-invoice-alpha-module"
	],
	"./main/invoice-sync/invoice-sync.module": [
		"./src/app/main/invoice-sync/invoice-sync.module.ts",
		"main-invoice-sync-invoice-sync-module"
	],
	"./main/leave-account/leave-account.module": [
		"./src/app/main/leave-account/leave-account.module.ts",
		"common",
		"main-leave-account-leave-account-module"
	],
	"./main/leave-allocation/leave-allocation.module": [
		"./src/app/main/leave-allocation/leave-allocation.module.ts",
		"common",
		"main-leave-allocation-leave-allocation-module"
	],
	"./main/leave-type/leave-type.module": [
		"./src/app/main/leave-type/leave-type.module.ts",
		"common",
		"main-leave-type-leave-type-module"
	],
	"./main/location/location.module": [
		"./src/app/main/location/location.module.ts"
	],
	"./main/market-level/market-level.module": [
		"./src/app/main/market-level/market-level.module.ts",
		"main-market-level-market-level-module"
	],
	"./main/market/market.module": [
		"./src/app/main/market/market.module.ts",
		"common",
		"main-market-market-module"
	],
	"./main/milage/milage.module": [
		"./src/app/main/milage/milage.module.ts",
		"main-milage-milage-module"
	],
	"./main/mpo-analytics/mpo-analytics.module": [
		"./src/app/main/mpo-analytics/mpo-analytics.module.ts",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~c24f09eb",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~8ad7246b",
		"main-mpo-analytics-mpo-analytics-module"
	],
	"./main/notice-board/notice-board.module": [
		"./src/app/main/notice-board/notice-board.module.ts",
		"common",
		"main-notice-board-notice-board-module"
	],
	"./main/order-alpha-approval-rule/order-alpha-approval-rule.module": [
		"./src/app/main/order-alpha-approval-rule/order-alpha-approval-rule.module.ts",
		"common",
		"main-order-alpha-approval-rule-order-alpha-approval-rule-module"
	],
	"./main/order-alpha/order-alpha.module": [
		"./src/app/main/order-alpha/order-alpha.module.ts",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~c24f09eb",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~8ad7246b",
		"common",
		"main-order-alpha-order-alpha-module"
	],
	"./main/order-report-chemist/order-report-chemist.module": [
		"./src/app/main/order-report-chemist/order-report-chemist.module.ts",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~c24f09eb",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~8ad7246b",
		"main-order-report-chemist-order-report-chemist-module"
	],
	"./main/order-report-detail/order-report-detail.module": [
		"./src/app/main/order-report-detail/order-report-detail.module.ts",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~c24f09eb",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~8ad7246b",
		"main-order-report-detail-order-report-detail-module"
	],
	"./main/order-report-product/order-report-product.module": [
		"./src/app/main/order-report-product/order-report-product.module.ts",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~c24f09eb",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~8ad7246b",
		"main-order-report-product-order-report-product-module"
	],
	"./main/order-report-user/order-report-user.module": [
		"./src/app/main/order-report-user/order-report-user.module.ts",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~c24f09eb",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~8ad7246b",
		"main-order-report-user-order-report-user-module"
	],
	"./main/order/order.module": [
		"./src/app/main/order/order.module.ts",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~c24f09eb",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~8ad7246b",
		"common",
		"main-order-order-module"
	],
	"./main/orderApproveRules/orderApproveRules.module": [
		"./src/app/main/orderApproveRules/orderApproveRules.module.ts",
		"main-orderApproveRules-orderApproveRules-module"
	],
	"./main/organization/organization.module": [
		"./src/app/main/organization/organization.module.ts",
		"common",
		"main-organization-organization-module"
	],
	"./main/patient-rx-order/patient-rx-order.module": [
		"./src/app/main/patient-rx-order/patient-rx-order.module.ts",
		"default~main-depot-depot-module~main-doctor-record-doctor-record-module~main-incentive-collection-in~90be9925",
		"common",
		"main-patient-rx-order-patient-rx-order-module"
	],
	"./main/patient-type/patient-type.module": [
		"./src/app/main/patient-type/patient-type.module.ts",
		"common",
		"main-patient-type-patient-type-module"
	],
	"./main/patient/patient.module": [
		"./src/app/main/patient/patient.module.ts",
		"default~main-allowance-allowance-module~main-central-stock-central-stock-module~main-exam-exam-modul~88d10046",
		"default~main-central-stock-central-stock-module~main-patient-patient-module",
		"common",
		"main-patient-patient-module"
	],
	"./main/payment-collection/payment-collection.module": [
		"./src/app/main/payment-collection/payment-collection.module.ts",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~c24f09eb",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~8ad7246b",
		"common",
		"main-payment-collection-payment-collection-module"
	],
	"./main/payment-method/payment-method.module": [
		"./src/app/main/payment-method/payment-method.module.ts",
		"common",
		"main-payment-method-payment-method-module"
	],
	"./main/payment/payment.module": [
		"./src/app/main/payment/payment.module.ts",
		"main-payment-payment-module"
	],
	"./main/paymentApproveRule/paymentApproveRule.module": [
		"./src/app/main/paymentApproveRule/paymentApproveRule.module.ts",
		"main-paymentApproveRule-paymentApproveRule-module"
	],
	"./main/prescription-type/prescription-type.module": [
		"./src/app/main/prescription-type/prescription-type.module.ts",
		"common",
		"main-prescription-type-prescription-type-module"
	],
	"./main/prescription/prescription.module": [
		"./src/app/main/prescription/prescription.module.ts",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~c24f09eb",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~8ad7246b",
		"common",
		"main-prescription-prescription-module"
	],
	"./main/product-brand-tag/product-brand-tag.module": [
		"./src/app/main/product-brand-tag/product-brand-tag.module.ts",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~c24f09eb",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~8ad7246b",
		"common",
		"main-product-brand-tag-product-brand-tag-module"
	],
	"./main/product-brand/product-brand.module": [
		"./src/app/main/product-brand/product-brand.module.ts",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~c24f09eb",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~8ad7246b",
		"common",
		"main-product-brand-product-brand-module"
	],
	"./main/product-dose/product-dose.module": [
		"./src/app/main/product-dose/product-dose.module.ts",
		"common",
		"main-product-dose-product-dose-module"
	],
	"./main/product-line/product-line.module": [
		"./src/app/main/product-line/product-line.module.ts",
		"common",
		"main-product-line-product-line-module"
	],
	"./main/product-price/product-price.module": [
		"./src/app/main/product-price/product-price.module.ts",
		"common",
		"main-product-price-product-price-module"
	],
	"./main/product-type/product-type.module": [
		"./src/app/main/product-type/product-type.module.ts",
		"common",
		"main-product-type-product-type-module"
	],
	"./main/product/product.module": [
		"./src/app/main/product/product.module.ts",
		"default~main-depot-depot-module~main-doctor-record-doctor-record-module~main-incentive-collection-in~222b3972",
		"common",
		"main-product-product-module"
	],
	"./main/reject-reason/reject-reason.module": [
		"./src/app/main/reject-reason/reject-reason.module.ts",
		"common",
		"main-reject-reason-reject-reason-module"
	],
	"./main/report-attendance/report-attendance.module": [
		"./src/app/main/report-attendance/report-attendance.module.ts",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~c24f09eb",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~8ad7246b",
		"default~main-depot-depot-module~main-doctor-record-doctor-record-module~main-incentive-collection-in~222b3972",
		"common",
		"main-report-attendance-report-attendance-module"
	],
	"./main/report-dcr/report-dcr.module": [
		"./src/app/main/report-dcr/report-dcr.module.ts",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~c24f09eb",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~8ad7246b",
		"default~main-depot-depot-module~main-doctor-record-doctor-record-module~main-incentive-collection-in~222b3972",
		"common",
		"main-report-dcr-report-dcr-module"
	],
	"./main/report-depot-stock/report-depot-stock.module": [
		"./src/app/main/report-depot-stock/report-depot-stock.module.ts",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~c24f09eb",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~8ad7246b",
		"default~main-chemist-ledger-chemist-ledger-module~main-dms-sales-return-dms-sales-return-module~main~658022d0",
		"main-report-depot-stock-report-depot-stock-module"
	],
	"./main/report-doctor-coverage/report-doctor-coverage.module": [
		"./src/app/main/report-doctor-coverage/report-doctor-coverage.module.ts",
		"main-report-doctor-coverage-report-doctor-coverage-module"
	],
	"./main/report-doctor/report-doctor.module": [
		"./src/app/main/report-doctor/report-doctor.module.ts",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~c24f09eb",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~8ad7246b",
		"common",
		"main-report-doctor-report-doctor-module"
	],
	"./main/report-invoice/report-invoice.module": [
		"./src/app/main/report-invoice/report-invoice.module.ts",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~c24f09eb",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~8ad7246b",
		"main-report-invoice-report-invoice-module"
	],
	"./main/report-monthly-expense-claim/monthly-expense-claim-report.module": [
		"./src/app/main/report-monthly-expense-claim/monthly-expense-claim-report.module.ts",
		"main-report-monthly-expense-claim-monthly-expense-claim-report-module"
	],
	"./main/report-order-alpha/report-order-alpha.module": [
		"./src/app/main/report-order-alpha/report-order-alpha.module.ts",
		"common",
		"main-report-order-alpha-report-order-alpha-module"
	],
	"./main/report-prescription/report-prescription.module": [
		"./src/app/main/report-prescription/report-prescription.module.ts",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~c24f09eb",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~8ad7246b",
		"default~main-depot-depot-module~main-doctor-record-doctor-record-module~main-incentive-collection-in~222b3972",
		"common",
		"main-report-prescription-report-prescription-module"
	],
	"./main/report-tour-plan/report-tour-plan.module": [
		"./src/app/main/report-tour-plan/report-tour-plan.module.ts",
		"main-report-tour-plan-report-tour-plan-module"
	],
	"./main/report-visitplan/report-visitplan.module": [
		"./src/app/main/report-visitplan/report-visitplan.module.ts",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~c24f09eb",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~8ad7246b",
		"main-report-visitplan-report-visitplan-module"
	],
	"./main/reportSampleAllocation/report-sample-allocation.module": [
		"./src/app/main/reportSampleAllocation/report-sample-allocation.module.ts",
		"default~main-depot-depot-module~main-doctor-record-doctor-record-module~main-incentive-collection-in~222b3972",
		"common",
		"main-reportSampleAllocation-report-sample-allocation-module"
	],
	"./main/return/return.module": [
		"./src/app/main/return/return.module.ts",
		"main-return-return-module"
	],
	"./main/role-wise-daily-allowance/role-wise-daily-allowance.module": [
		"./src/app/main/role-wise-daily-allowance/role-wise-daily-allowance.module.ts",
		"common",
		"main-role-wise-daily-allowance-role-wise-daily-allowance-module"
	],
	"./main/role-wise-expense-type/role-wise-expense-type.module": [
		"./src/app/main/role-wise-expense-type/role-wise-expense-type.module.ts",
		"common",
		"main-role-wise-expense-type-role-wise-expense-type-module"
	],
	"./main/route/route.module": [
		"./src/app/main/route/route.module.ts",
		"common",
		"main-route-route-module"
	],
	"./main/rx-survey-type/rx-survey-type.module": [
		"./src/app/main/rx-survey-type/rx-survey-type.module.ts",
		"common",
		"main-rx-survey-type-rx-survey-type-module"
	],
	"./main/rx-survey/rx-survey.module": [
		"./src/app/main/rx-survey/rx-survey.module.ts",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~c24f09eb",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~8ad7246b",
		"default~main-chemistSurveyRespnd-chemist-survey-respond-module~main-dashboard-dashboard-module~main-~99ead755",
		"main-rx-survey-rx-survey-module"
	],
	"./main/rx/rx.module": [
		"./src/app/main/rx/rx.module.ts",
		"main-rx-rx-module"
	],
	"./main/sales-center/sales-center.module": [
		"./src/app/main/sales-center/sales-center.module.ts",
		"common",
		"main-sales-center-sales-center-module"
	],
	"./main/sales-report/sales-report.module": [
		"./src/app/main/sales-report/sales-report.module.ts",
		"common",
		"main-sales-report-sales-report-module"
	],
	"./main/sample-gift-challan/sample-gift-challan.module": [
		"./src/app/main/sample-gift-challan/sample-gift-challan.module.ts",
		"main-sample-gift-challan-sample-gift-challan-module"
	],
	"./main/sample-stock/sample-stock.module": [
		"./src/app/main/sample-stock/sample-stock.module.ts",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~c24f09eb",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~8ad7246b",
		"common",
		"main-sample-stock-sample-stock-module"
	],
	"./main/sampleAllocation/sample-allocation.module": [
		"./src/app/main/sampleAllocation/sample-allocation.module.ts",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~c24f09eb",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~8ad7246b",
		"common",
		"main-sampleAllocation-sample-allocation-module"
	],
	"./main/seen-rx/seen-rx.module": [
		"./src/app/main/seen-rx/seen-rx.module.ts",
		"main-seen-rx-seen-rx-module"
	],
	"./main/segment/segment.module": [
		"./src/app/main/segment/segment.module.ts",
		"common",
		"main-segment-segment-module"
	],
	"./main/site-owner-type/siteOwner.module": [
		"./src/app/main/site-owner-type/siteOwner.module.ts",
		"common",
		"main-site-owner-type-siteOwner-module"
	],
	"./main/site-visit-type/site-visit-type.module": [
		"./src/app/main/site-visit-type/site-visit-type.module.ts",
		"common",
		"main-site-visit-type-site-visit-type-module"
	],
	"./main/site/site.module": [
		"./src/app/main/site/site.module.ts",
		"common",
		"main-site-site-module"
	],
	"./main/siteType/siteType.module": [
		"./src/app/main/siteType/siteType.module.ts",
		"common",
		"main-siteType-siteType-module"
	],
	"./main/siteVisit/siteVisit.module": [
		"./src/app/main/siteVisit/siteVisit.module.ts",
		"common",
		"main-siteVisit-siteVisit-module"
	],
	"./main/special-day/special-day.module": [
		"./src/app/main/special-day/special-day.module.ts",
		"common",
		"main-special-day-special-day-module"
	],
	"./main/speciality/speciality.module": [
		"./src/app/main/speciality/speciality.module.ts",
		"common",
		"main-speciality-speciality-module"
	],
	"./main/stock/stock.module": [
		"./src/app/main/stock/stock.module.ts",
		"common",
		"main-stock-stock-module"
	],
	"./main/sub-segment/sub-segment.module": [
		"./src/app/main/sub-segment/sub-segment.module.ts",
		"common",
		"main-sub-segment-sub-segment-module"
	],
	"./main/sub-speciality/sub-speciality.module": [
		"./src/app/main/sub-speciality/sub-speciality.module.ts",
		"common",
		"main-sub-speciality-sub-speciality-module"
	],
	"./main/survey-doctor/survey-doctor.module": [
		"./src/app/main/survey-doctor/survey-doctor.module.ts",
		"default~main-chemistSurveyRespnd-chemist-survey-respond-module~main-dashboard-dashboard-module~main-~99ead755",
		"default~main-doctor-doctor-module~main-survey-doctor-survey-doctor-module",
		"main-survey-doctor-survey-doctor-module"
	],
	"./main/survey-type/survey-type.module": [
		"./src/app/main/survey-type/survey-type.module.ts",
		"default~main-allowance-allowance-module~main-central-stock-central-stock-module~main-exam-exam-modul~88d10046",
		"default~main-allowance-allowance-module~main-exam-exam-module~main-exam-v2-exam-v2-module~main-surve~592641c7",
		"main-survey-type-survey-type-module"
	],
	"./main/survey/survey.module": [
		"./src/app/main/survey/survey.module.ts",
		"default~main-allowance-allowance-module~main-central-stock-central-stock-module~main-exam-exam-modul~88d10046",
		"default~main-allowance-allowance-module~main-exam-exam-module~main-exam-v2-exam-v2-module~main-surve~592641c7",
		"common",
		"main-survey-survey-module"
	],
	"./main/surveyChemistApproveRules/suveyChemistApproveRules.module": [
		"./src/app/main/surveyChemistApproveRules/suveyChemistApproveRules.module.ts",
		"common",
		"main-surveyChemistApproveRules-suveyChemistApproveRules-module"
	],
	"./main/surveyDoctorApproveRules/suveyDoctorApproveRules.module": [
		"./src/app/main/surveyDoctorApproveRules/suveyDoctorApproveRules.module.ts",
		"common",
		"main-surveyDoctorApproveRules-suveyDoctorApproveRules-module"
	],
	"./main/surveySiteApproveRules/suveySiteApproveRules.module": [
		"./src/app/main/surveySiteApproveRules/suveySiteApproveRules.module.ts",
		"common",
		"main-surveySiteApproveRules-suveySiteApproveRules-module"
	],
	"./main/ta-da-approval-rules/ta-da-approval-rules.module": [
		"./src/app/main/ta-da-approval-rules/ta-da-approval-rules.module.ts",
		"main-ta-da-approval-rules-ta-da-approval-rules-module"
	],
	"./main/tada-MarketRule/market-rule.module": [
		"./src/app/main/tada-MarketRule/market-rule.module.ts",
		"main-tada-MarketRule-market-rule-module"
	],
	"./main/tadaClaim/tadaClaim.module": [
		"./src/app/main/tadaClaim/tadaClaim.module.ts",
		"common",
		"main-tadaClaim-tadaClaim-module"
	],
	"./main/target/target.module": [
		"./src/app/main/target/target.module.ts",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~c24f09eb",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~8ad7246b",
		"default~main-depot-depot-module~main-doctor-record-doctor-record-module~main-incentive-collection-in~222b3972",
		"default~main-depot-depot-module~main-doctor-record-doctor-record-module~main-incentive-collection-in~90be9925",
		"common",
		"main-target-target-module"
	],
	"./main/therapeutic-group/therapeutic-group.module": [
		"./src/app/main/therapeutic-group/therapeutic-group.module.ts",
		"common",
		"main-therapeutic-group-therapeutic-group-module"
	],
	"./main/tour-plan/tour-plan.module": [
		"./src/app/main/tour-plan/tour-plan.module.ts",
		"common",
		"main-tour-plan-tour-plan-module"
	],
	"./main/tour-purpose/tour-purpose.module": [
		"./src/app/main/tour-purpose/tour-purpose.module.ts",
		"common",
		"main-tour-purpose-tour-purpose-module"
	],
	"./main/tour-type/tour-type.module": [
		"./src/app/main/tour-type/tour-type.module.ts",
		"common",
		"main-tour-type-tour-type-module"
	],
	"./main/tourApproveRules/tourApproveRules.module": [
		"./src/app/main/tourApproveRules/tourApproveRules.module.ts",
		"main-tourApproveRules-tourApproveRules-module"
	],
	"./main/training/training.module": [
		"./src/app/main/training/training.module.ts",
		"default~main-allowance-allowance-module~main-central-stock-central-stock-module~main-exam-exam-modul~88d10046",
		"default~main-allowance-allowance-module~main-exam-exam-module~main-exam-v2-exam-v2-module~main-surve~592641c7",
		"common",
		"main-training-training-module"
	],
	"./main/transport/transport.module": [
		"./src/app/main/transport/transport.module.ts",
		"default~main-allowance-allowance-module~main-central-stock-central-stock-module~main-exam-exam-modul~88d10046",
		"default~main-allowance-allowance-module~main-exam-exam-module~main-exam-v2-exam-v2-module~main-surve~592641c7",
		"common",
		"main-transport-transport-module"
	],
	"./main/user-allowance-approval-rule/user-allowance-approval-rule.module": [
		"./src/app/main/user-allowance-approval-rule/user-allowance-approval-rule.module.ts",
		"common",
		"main-user-allowance-approval-rule-user-allowance-approval-rule-module"
	],
	"./main/user-allowance/user-allowance.module": [
		"./src/app/main/user-allowance/user-allowance.module.ts",
		"common",
		"main-user-allowance-user-allowance-module"
	],
	"./main/user-distance-wise-tada-rule/user-distance-wise-tada-rule.module": [
		"./src/app/main/user-distance-wise-tada-rule/user-distance-wise-tada-rule.module.ts",
		"default~main-depot-depot-module~main-doctor-record-doctor-record-module~main-incentive-collection-in~222b3972",
		"default~main-depot-depot-module~main-doctor-record-doctor-record-module~main-incentive-collection-in~90be9925",
		"main-user-distance-wise-tada-rule-user-distance-wise-tada-rule-module"
	],
	"./main/user-leave/user-leave.module": [
		"./src/app/main/user-leave/user-leave.module.ts",
		"common",
		"main-user-leave-user-leave-module"
	],
	"./main/user-ledger/user-ledger.module": [
		"./src/app/main/user-ledger/user-ledger.module.ts",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~c24f09eb",
		"default~main-activeDayCountReport-activeDayCount-module~main-adjust-payment-adjust-payment-module~ma~8ad7246b",
		"default~main-chemist-ledger-chemist-ledger-module~main-dms-sales-return-dms-sales-return-module~main~658022d0",
		"main-user-ledger-user-ledger-module"
	],
	"./main/user-role-wise-allowance-rule/user-role-wise-allowance-rule.module": [
		"./src/app/main/user-role-wise-allowance-rule/user-role-wise-allowance-rule.module.ts",
		"common",
		"main-user-role-wise-allowance-rule-user-role-wise-allowance-rule-module"
	],
	"./main/user-role/user-role.module": [
		"./src/app/main/user-role/user-role.module.ts",
		"common",
		"main-user-role-user-role-module"
	],
	"./main/user/user.module": [
		"./src/app/main/user/user.module.ts",
		"default~main-depot-depot-module~main-doctor-record-doctor-record-module~main-incentive-collection-in~222b3972",
		"default~main-depot-depot-module~main-doctor-record-doctor-record-module~main-incentive-collection-in~90be9925",
		"common",
		"main-user-user-module"
	],
	"./main/userleaveApproveRules/userleaveApproveRules.module": [
		"./src/app/main/userleaveApproveRules/userleaveApproveRules.module.ts",
		"main-userleaveApproveRules-userleaveApproveRules-module"
	],
	"./main/vehicle/vehicle.module": [
		"./src/app/main/vehicle/vehicle.module.ts",
		"common",
		"main-vehicle-vehicle-module"
	],
	"./main/visitApproveRules/visitApproveRules.module": [
		"./src/app/main/visitApproveRules/visitApproveRules.module.ts",
		"common",
		"main-visitApproveRules-visitApproveRules-module"
	],
	"./main/weekend/weekend.module": [
		"./src/app/main/weekend/weekend.module.ts",
		"common",
		"main-weekend-weekend-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;